<template>
    <ul class="list-unstyled">
        <template v-for="(entry, i) in entries">
            <li v-if="entry.content !== undefined && entry.content !== 0" :key="i">
                <i v-if="entry.icon !== undefined" :class="`fas ${entry.icon} fa-fw`" data-toggle="tooltip" data-placement="top" :title="entry.tooltip"></i>
                {{ entry.content }}
                <div v-if="entry.additional" id="additional">{{ entry.additional }}</div>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    name: "UnstyledList",
    props: {
        entries: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    mounted() {
        // Enable all the tooltips
        $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>

<style lang="scss" scoped>
#additional {
    white-space: pre;
    margin-bottom: 16px;
    margin-left: 24px
}


</style>